import { IOffer } from '../offer/types';
import { IUserLevelInfoSchema } from '../repositories/search-offers.legacy/v2/types/UserLevelInfoSchema';

import { extractUndefined } from './extractUndefined';

export function getAgentLevelInfo(offer: IOffer): IUserLevelInfoSchema | null {
  return extractUndefined(offer.user?.agentModerationInfo?.userLevelInfo);
}
